import { CurrencyEnum, Transaction, TransactionTypeEnum } from "@finway-group/shared/lib/models"

export const isTransactionArchived = (transaction: Pick<Transaction, "isArchived">) => transaction.isArchived

export const isTransactionManuallyUnarchived = (transaction: Pick<Transaction, "isAutoArchiveOff">) => transaction.isAutoArchiveOff

export const getVendorIdsFromTransactions = (transactions: Array<Transaction>) => transactions.map((transaction) => transaction.transactionData.vendor).filter((vendor) => vendor)

export const getSourceCurrency = (transaction: Transaction) => {
    try {
        if (transaction.transactionType === TransactionTypeEnum.CSV_TRANSACTION) {
            return transaction.transactionData?.currency ?? CurrencyEnum.EUR
        }
        const rawContent = JSON.parse(`${(transaction as any).sourceRawContent}`)
        return rawContent.sourceCurrency
    } catch (error) {
        return undefined
    }
}
